import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, Subscription, Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  statusSend = new Subject<boolean>()
  statusForm = new BehaviorSubject<string>('')
  datastatus = this.statusForm.asObservable


  constructor(private http: HttpClient) { }

  sendHire(body: any): Observable<any>{
    if(body > 0){
      this.statusForm.next('success')
      return this.http.post(`${environment.fireBase}pesan-hiring.json`, body) as Observable<any>
    }else{
      this.statusForm.next('error')
    }
    return this.statusForm
  }

  downloadPdfCv(){
    return this.http.get('../../../assets/file/cvterbaru-dikompresi.pdf', { responseType: 'blob' })
  }

  getHireData(){
    return this.http.get(`${environment.express}hire/hire-get`)
  }

  deleteHireData(id: any){
    return this.http.delete(`${environment.express}hire/hire-delete/${id}`)
  }

  doSendHire(body: any){
    return this.http.post(`${environment.express}hire/send-hire`, body)
  }

  getStory(){
    return this.http.get(`${environment.express}story/story`)
  }
}
